import * as next from '../../../types/next'
import { getBlockNameByScope } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { nonEmptyStringOrUndefined, upCommonSettings } from './common'

export const up: UpBlockHandler<next.TextInputBlock> = (uischema, schema) => {
  if (uischema.type !== 'Control') {
    throw new Error('Control')
  }
  const name = getBlockNameByScope(uischema.scope) ?? uischema.options?.title
  const options = uischema.options || {}

  return {
    id: uischema.id,
    name: name,
    required: schema?.required?.includes(name),
    type: next.BLOCK_TYPE.TEXT_INPUT,
    settings: {
      ...upCommonSettings(uischema),
      label: nonEmptyStringOrUndefined(options.label),
      placeholder: schema?.properties?.[name]?.examples?.[0],
      multiline: options.multiline || false
    },
    references: {}
  }
}
